export const RECEIVED_RECOMMENDATIONS_DATA = 'RECEIVED_RECOMMENDATIONS_DATA'
export const RECEIVED_RECOMMENDATIONS_DATA_ERROR = 'RECEIVED_RECOMMENDATIONS_DATA_ERROR'

export function recievedRecommedationsAction(payload) {
  return {
    type: RECEIVED_RECOMMENDATIONS_DATA,
    payload: {
      ...payload,
      isInitialized: true,
      recievedError: false,
    },
  }
}

export function recievedErrorAction(payload) {
  return {
    type: RECEIVED_RECOMMENDATIONS_DATA_ERROR,
    payload: {
      isInitialized: false,
      recievedError: true,
    },
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/recommendedVideos/recommendedVideos.actions.js